/* tslint:disable */
import zenObservable from 'zen-observable';
export var Observable = zenObservable;
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/zen-observable-ts/lib/zenObservable.js
// module id = 1305
// module chunks = 0